import {SquareIcon} from './icons'

export const Google: SquareIcon = ({size = 20}) => (
  <svg width={size} height={size} viewBox='0 0 17 17' fill='none'>
    <g clipPath='url(#clip0_14_36191)'>
      <path
        d='M16.8343 8.6958C16.8343 8.11799 16.7875 7.53706 16.6875 6.96863H8.67004V10.2418H13.2613C13.0708 11.2975 12.4586 12.2314 11.5622 12.8248V14.9486H14.3013C15.9098 13.4682 16.8343 11.2819 16.8343 8.6958Z'
        fill='#4285F4'
      />
      <path
        d='M8.67003 17.0006C10.9625 17.0006 12.8958 16.2479 14.3044 14.9486L11.5653 12.8248C10.8032 13.3432 9.8194 13.6368 8.67315 13.6368C6.45563 13.6368 4.57541 12.1408 3.90079 10.1294H1.07422V12.3188C2.51717 15.1891 5.45618 17.0006 8.67003 17.0006V17.0006Z'
        fill='#34A853'
      />
      <path
        d='M3.89768 10.1294C3.54162 9.07369 3.54162 7.93057 3.89768 6.8749V4.68549H1.07423C-0.131352 7.08729 -0.131352 9.91697 1.07423 12.3188L3.89768 10.1294V10.1294Z'
        fill='#FBBC04'
      />
      <path
        d='M8.67003 3.36434C9.88186 3.3456 11.0531 3.8016 11.9307 4.63864L14.3575 2.21185C12.8209 0.768899 10.7814 -0.0244134 8.67003 0.000572805C5.45618 0.000572805 2.51717 1.81207 1.07422 4.68549L3.89766 6.87491C4.56917 4.86039 6.4525 3.36434 8.67003 3.36434V3.36434Z'
        fill='#EA4335'
      />
    </g>
    <defs>
      <clipPath id='clip0_14_36191'>
        <rect width='17' height='17' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
